import React, { useEffect, useState } from 'react';
import { AttachFile, Send } from '@mui/icons-material';
import { IconButton, Stack, TextField, TextFieldProps, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface IChatMessageInputProps extends Omit<TextFieldProps, 'sx'> {
    /**
     * The list of members in the chat which are currently typing
     */
    typingMembers?: string[];
    onAttachFileClick?: () => Promise<any>;
    onSendClick: (message: string, media?: any) => Promise<void>;
    /** The initial value */
    value: string;
}

export const ChatMessageInput = ({ typingMembers, onAttachFileClick, onSendClick, disabled, onChange, ...restProps }: IChatMessageInputProps) => {
    const { t } = useTranslation();
    const [value, setValue] = useState<string>((restProps.value || "") as string);
    const [isSending, setIsSending] = useState(false);

    useEffect(() => {
        setValue(restProps.value)
    }, [restProps.value])

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange?.(event);
        setValue(event.target.value);
    };

    const handleAttachFileClick = async () => {
        await onAttachFileClick?.();
    }

    const handleSendClick = () => {
        setIsSending(true)
        onSendClick(value)
            .then(() => {
                setIsSending(false);
                setValue('');
            });
    }

    const handleKeyPress: React.KeyboardEventHandler<HTMLDivElement> = (event) => {
        if (event.key === "Enter" && !event.shiftKey) {
            //send message when Enter is pressed (unless shift key down too: hard return)
            handleSendClick();
        }
    }

    return (
        <Stack>
            {
                !!typingMembers && typingMembers.length > 0 &&
                <Typography>{typingMembers.join(' and ') + " typing"}</Typography>
            }
            <Stack direction={'row'}
                justifyContent={'space-between'}
                alignItems={'center'}>
                <TextField
                    sx={{ flex: 1 }}
                    placeholder={t('chat.thread.inputPlaceholder')}
                    multiline
                    maxRows={4}
                    {...restProps}
                    value={value}
                    onChange={handleChange}
                    onKeyDown={handleKeyPress}
                    disabled={disabled || isSending}
                />
                {!!onAttachFileClick && <IconButton onClick={handleAttachFileClick} disabled={disabled || isSending}><AttachFile /></IconButton>}
                <IconButton onClick={handleSendClick} disabled={disabled || isSending || !restProps.value.trim()}><Send /></IconButton>
            </Stack>
        </Stack>
    )
}